<template>
	<div class="self-service-container">
		<Loading v-if="loading" :size="48" />
		<template v-else>
			<ServiceHeader
				:topContent="servicePage.top_content" 
				:serviceProgressFeature="serviceProgressFeature"
				:userGuideFeature="userGuideFeature"
				:topImg="servicePage.top_img"
			/>
			<div class="self-service-main">
				<div class="welcome-txt">{{ servicePage.top_content }}</div>
				<Recommend
					:services="services"
					:recommendContent="servicePage.recommend_content"
					:appid="appid"
					:servicePageData="servicePageData"
					:userGuideFeature="userGuideFeature"
				/>
				<TopQuestions :questionContent="servicePage.question_content" :appid="appid" :enterid="enterid" :sign="sign" />
				<serviceBottom :butlerFeature="butlerFeature" />
			</div>
		</template>
	</div>
</template>

<script>
import getSearchParams from '@/utils/getSearchParams'
import api from '@/api/api.js'
import { track, getBrandFromBridge } from '@/utils/tracking.js'
import serviceBottom from './serviceBottom.vue'
import ServiceHeader from './ServiceHeader.vue'
import Recommend from './recommend.vue'
import TopQuestions from './TopQuestions.vue'
import Loading from '@/components/common/components/loading.vue'

const defaultServicePage = {
	question_content: '猜你想问',
	recommend_content: '推荐服务',
	top_content: 'Hi～欢迎使用小方专属客服！',
	top_img: '',
}

const { appid, enterid, sign } = getSearchParams()

export default {
	components: {
		serviceBottom,
		ServiceHeader,
		Recommend,
		TopQuestions,
		Loading,
		// OrderCard,
	},
	data() {
		return {
			servicePage: defaultServicePage,
			services: [],
			appid,
			enterid,
			sign,
			servicePageData: null,
			butlerFeature: null,
			serviceProgressFeature: null,
			userGuideFeature: null,
			loading: true,
		}
	},
	methods: {
		waitForBridgeAndTrack() {
			console.log('这段导函数执行了吗')
			const maxWaitTime = 5000
			const startTime = Date.now()

			const checkBridge = () => {
				console.log('进入checkBridge')
				try {
					console.log('get brand前')
					const brand = localStorage.getItem('brand')
					console.log('get brand后','brand==>',brand)
					if (localStorage.getItem('brand')) {
						// ✅ 成功获取 bridge，执行埋点
						console.log('去埋点了')
						track({
							param: {
								eventCode: 'self_service_page_view',
								pageCode: 'self_service_page'
							}
						})
					} else if (Date.now() - startTime < maxWaitTime) {
						getBrandFromBridge()
						// ✅ 未获取到 bridge，继续轮询
						requestAnimationFrame(checkBridge)

						console.log('requestAnimationFrame 继续轮询')
					} else {
						console.log('[Tracking] 等待桥接超时，跳过埋点')
					}
				} catch (err) {
					// ✅ 捕获 getBridge() 报错，不中断轮询
					console.log('[Tracking] 获取 bridge 失败，继续轮询:', err)

					// ⚠️ 注意：即使报错，也要继续尝试
					if (Date.now() - startTime < maxWaitTime) {
						console.log('requestAnimationFrame 继续轮询')
						getBrandFromBridge()
						requestAnimationFrame(checkBridge)
					} else {
						console.log('[Tracking] 等待桥接超时，跳过埋点')
					}
				}
			}

			// ✅ 第一次触发轮询
			requestAnimationFrame(checkBridge)
		},

		/**
		 * 只有当页面从 hidden → visible 时才会触发。
		 * 比如：
		 * 用户从其他 App 回退到当前 H5 页面
		 * 浏览器标签页切换回来
		 * App 内嵌页返回> ⚠️ 但：页面首次 mounted 时，visibilityState 本来就是 'visible'，不会触发 visibilitychange 事件！
		 * */
		handleVisibilityChange() {
			console.log('visibilityState==>', document.visibilityState)
			if (document.visibilityState === 'visible') {
				track({
					param: {
						eventCode: 'self_service_page_view',
						pageCode: 'self_service_page',
					},
				})
			}
		},

		getInitInfo() {
			this.loading = true
			api
				.getCard({
					appId: appid,
					enterId: enterid,
					sign: sign,
				})
				.then(res => {
					console.log('getInitInfo', res)
					if (res) {
						this.servicePage = res.servicePage || defaultServicePage
						this.services = res.cardList || []
						// 设置背景图
						this.setTopImgBackground()
					}
				})
				.finally(() => {
					this.loading = false
				})
		},

		setAppStyle() {
			document.querySelector('.app').classList.add('bg-f5f7fa')
		},
		setTopImgBackground() {
			if (this.servicePage.top_img) {
				document.querySelector('.self-service-container').style.backgroundImage = `url(${this.servicePage.top_img})`
			}
		},
		resetAppStyle() {
			document.querySelector('.app').classList.remove('bg-f5f7fa')
		},

		handleServicePageData() {
			const _servicePageData = JSON.parse(process.env.VUE_APP_SERVICE_PAGE_DATA)
			this.servicePageData = _servicePageData
			this.findData()
		},
		findData() {
			// 查找精诚管家、使用手册、服务进度
			if (!this.servicePageData) {
				return null
			}

			const modules = this.servicePageData.modules || []
			modules.forEach(module => {
				const features = module.features || []
				features.forEach(feature => {
					if (feature.feature_name === '用户手册') {
						this.userGuideFeature = feature
					} else if (feature.feature_name === '服务进度') {
						this.serviceProgressFeature = feature
					} else if (feature.feature_name === '精诚服务管家') {
						this.butlerFeature = feature
					}
				})
			})
		},
	},
	mounted() {
		this.getInitInfo()
		this.setAppStyle()
		this.handleServicePageData()
		this.waitForBridgeAndTrack()
		document.addEventListener('visibilitychange', this.handleVisibilityChange)
	},
	beforeDestroy() {
		this.resetAppStyle()
		document.removeEventListener('visibilitychange', this.handleVisibilityChange)
	},
}
</script>

<style lang="less">
html,
body,
.app {
	height: 100dvh;
	min-height: -webkit-fill-available;
	box-sizing: border-box;
}

.app.bg-f5f7fa {
	background-color: #f5f7fa;
}
</style>
<style scoped lang="less">
.self-service-container {
	background-size: 100% auto;
	background-repeat: no-repeat;
	background-position: center top;
	height: 100%;
	background-color: #f5f7fa;
	display: flex;
	flex-direction: column;
	.self-service-main {
		.px2rem(padding, 12);
		padding-bottom: calc(1.6rem + env(safe-area-inset-bottom, 0px));
		flex: 1;
		overflow-y: auto;
	}

	.welcome-txt {
		color: #1a1d25;
		font-family: 'HYQiHei';
		font-weight: 500;
		.px2rem(font-size, 18);
		.px2rem(line-height, 22);
		.px2rem(margin-bottom, 12);
		.px2rem(padding-left, 12);
	}
}
</style>
